export default {
	namespaced: true,
	actions: {
		trackEvent(context, event) {
			// eslint-disable-next-line
			this._vm.$gtag.event(event);
		},
		trackPageView(context, page) {
			const view = { ...page, documentReferrer: document.referrer };
			// eslint-disable-next-line
			this._vm.$gtag.pageview(view);
		},
		trackEndgameEvents({ dispatch, rootState, rootGetters }, game) {
			const eventCategory = "End Game";
			const balanceGetter = rootGetters["game/funds/balance"];

			dispatch("trackPageView", { dp: "vegas" });

			dispatch("trackEvent", { eventCategory, ea: "Game Outcome", el: game.state });
			dispatch("trackEvent", { eventCategory, ea: "Magic Shop Fund", el: balanceGetter("spendable") });
			dispatch("trackEvent", { eventCategory, ea: "Amount Saved", el: balanceGetter("required") });
			dispatch("trackEvent", { eventCategory, ea: "Final Stage", el: rootState.game.chapters.index + 1 });

			rootGetters["game/scores/array"].forEach((score) => {
				dispatch("trackEvent", { eventCategory, ea: score.title, el: score.value });
			});
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/global/analytics.store.js